<template>
  <div>
    <div class="tenant-expired-header">
      <AssetV3
        dir="logos"
        name="logo.svg"
      />
    </div>

    <div class="tenant-expired-body">
      <AssetV3
        dir="icons"
        name="square-rounded-thumbnail-error.svg"
      />

      <h2>Proposta expirada</h2>

      <p class="gray-700">
        Infelizmente essa proposta já expirou. Entre em contato com seu
        corretor para mais informações.
      </p>
    </div>
  </div>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'tenantExpired',
  metaInfo: {
    title: 'Proposta Expirada',
  },
  components: {
    AssetV3,
  },
};
</script>

<style lang="scss" scoped>
  .tenant-expired-header {
    display: flex;
    justify-content: center;
    width: 100%;
    img {
      width: 150px;
      height: 32px;
    }
  }

  .tenant-expired-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    align-items: center;
    color:  var(--gray-700);
  }
</style>
